lmApp
  .service('IMDbService', ['$rootScope', '$templateCache', '$compile', '$q', '$timeout', 'AssetService', 'MetadataService', 'ModalWindowService', 'ToastService',
    function ($rootScope, $templateCache, $compile, $q, $timeout, AssetService, MetadataService, ModalWindowService, ToastService) {
      var service = {};
      /**
       * Fetch data from IMDB
       * @param title
       * @param $scope
       * @param type
       */
      service.FetchFromIMDB = function (title, $scope, type, season, episode) {
        if (!title) return;

        $scope.$parent.loading = true;
        $rootScope.showLinearProgress('#modalLoader');

        var titleToShow = title;
        if (season) {
          titleToShow = title + ' s' + season + 'e' + episode
        }

        ToastService.Big({
          title: 'Searching for "' + titleToShow + '"',
          text: 'We are searching related data on IMDb. Please, be patient',
          color: 'amber',
          icon: 'magnify'
        }, 600 * 1000);

        AssetService.GetIMDBCollection(encodeURIComponent(title), type, season, episode)
          .then(function (collection) {
            $scope.$parent.loading = false;
            $rootScope.hideLinearProgress('#modalLoader');
            ToastService.HideBig();

            var imdbInnerScope = $scope.$new(true);
            /**
             * @param {{title_popular:Array,
             *          title_exact:Array,
             *          title_substring:Array}} collection
             */

            if (!collection) {
              throw null;
            }

            imdbInnerScope.imdbCollection = collection;

            imdbInnerScope.selected = {
              asset: {},
              index: -1
            };

            imdbInnerScope.isSelected = function (index) {
              return index === imdbInnerScope.selected.index;
            };

            imdbInnerScope.selectItem = function (index) {
              return imdbInnerScope.selected.index = index;
            };

            var inner = $templateCache.get('imdb-import.html');

            inner = $compile(inner)(imdbInnerScope);

            $scope.window = ModalWindowService.Open({
              content: inner,
              isFixed: true,
              keyboard: true,
              actions: [
                {
                  title: 'Import Selected',
                  color: 'green',
                  fn: function () {
                    if (imdbInnerScope.selected.index !== -1) {
                      $scope.$parent.loading = true;
                      $rootScope.showLinearProgress('#modalLoader');

                      AssetService.GetIMDBItem(imdbInnerScope.imdbCollection[imdbInnerScope.selected.index].imdbID)
                        .then(function (response) {
                          var movie = _.pickBy(response, function (field) {
                            return field !== 'N/A'
                          });
                          service.AutoFill($scope.assetData, movie, $scope);
                        });
                    }
                  }
                },
                {
                  title: 'Cancel',
                  color: 'red'
                }
              ],
              size: {
                s: 10,
                l: 6
              }
            });
          }, function () {
            $scope.$parent.loading = false;
            $rootScope.hideLinearProgress('#modalLoader');
            ToastService.Big({
              title: 'Searching for "' + title + '"',
              text: 'We can\'t reach IMDb. Sorry, for disappointment You.',
              color: 'deep-orange',
              icon: 'emoticon-sad'
            }, 60 * 1000);
          })
          .catch(function (reason) {
            $rootScope.debugInfo(reason);
          });
      };

      /**
       * Autofill data to asset
       */
      service.AutoFill = function (asset, data, $scope) {
        $scope.$parent.loading = true;
        $rootScope.showLinearProgress('#modalLoader');
        ToastService.Big({
          title: 'Import',
          text: 'We a doing import from IMDb. Please, be patient.',
          color: 'amber',
          icon: 'clock-fast'
        }, 60 * 1000);
        if (data.imdbID) {
          var deferred = $q.defer();
          asset.title = _.unescape(data.Title);
          asset.year = data.Year;

          var duration;
          if (data.Runtime) {
            duration = parseInt(data.Runtime.split(' ')[0], 10);
          }
          if (duration) {
            asset._PrivateData.durationNew = duration * 60;
          }

          var description = data.Plot;
          if (description) {
            asset.description = description;
          }

          if (data.imdbRating) {
            var imdb = _.find(asset._PrivateData.ratingsNew, {type: 'imdb'});

            if (imdb) {
              imdb.value = data.imdbRating;
              imdb.votes_count = data.imdbVotes.replace(',', '') || 0
            } else {
              asset._PrivateData.ratingsNew.push({
                type: 'imdb',
                value: data.imdbRating,
                votes_count: data.imdbVotes.replace(',', '') || 0,
                label: 'IMDb'
              });
            }
          }

          if (data.Metascore) {

            var metascore = _.find(asset._PrivateData.ratingsNew, {type: 'metascore'});

            if (metascore) {
              metascore.value = data.Metascore;
              metascore.votes_count = 0;
            } else {
              asset._PrivateData.ratingsNew.push({
                type: 'metascore',
                value: data.Metascore,
                votes_count: 0,
                label: 'Metascore'
              });
            }
          }

          if (data.Rated) {

            var mpaa = _.find(asset._PrivateData.ratingsNew, {type: 'mpaa'});

            if (mpaa) {
              mpaa.value = _.find(MetadataService.Rating.mpaaValues, {id: data.Rated});
            } else {
              asset._PrivateData.ratingsNew.push({
                type: 'mpaa',
                value: _.find(MetadataService.Rating.mpaaValues, {id: data.Rated}),
                label: 'MPAA'
              });
            }
          }

          var allQ = {};

          if (asset.type === 'tv_episode') {
            asset._PrivateData.posterNew = data.Poster;
          } else {
            asset._PrivateData.posterNew = 'http://admin-ams.sotalcloud.com/imdb/find/poster/' + data.imdbID;
          }

          //asset._PrivateData.posterNew = 'http://lm.local:5555/imdb/find/poster/' + data.imdbID;
          asset._PrivateData.posterUrl = asset._PrivateData.posterNew;

          allQ.genres = (function () {
            var parseGenres = _.get(data, 'Genre', '')
              .split(',')
              .map(function (item) {
                return {
                  title: item.trim()
                };
              });

            var newGenres = _.filter($scope.genreSearch, function (genre) {
              return _.find(parseGenres, {title: genre.title});
            });

            if (newGenres.length) asset._PrivateData.genresNew = newGenres;
          })();

          allQ.persons = (function () {
            var deferred = $q.defer();

            if (data.Director) var parseDirectors = data.Director.split(',').map(function (item) {
              return {role: 'director', name: item.replace('(screenplay)', '').replace('(story)', '').trim()};
            });
            if (data.Writer) var parseWriters = data.Writer.split(',').map(function (item) {
              return {role: 'scenario', name: item.replace('(screenplay)', '').replace('(story)', '').trim()};
            });
            if (data.Actors) var parseActors = data.Actors.split(',').map(function (item) {
              return {role: 'actor', name: item.replace('(screenplay)', '').replace('(story)', '').trim()};
            });

            var persons = _.union(parseDirectors, parseWriters, parseActors);

            var personSearchResult = [];

            var requestQ = persons.map(function (person) {
              return AssetService.SearchPerson(person.name, person.role)
                .then(function (response) {
                  if (response.length) personSearchResult.push(response[0])
                });
            });

            if (data.Type === 'movie' && $scope.categorySearch) {
              asset._PrivateData.categoriesNew = [];
              asset._PrivateData.categoriesNew = $scope.categorySearch.filter(function (category) {
                return category.title === 'Movies';
              });
            }

            if (data.Type === 'series' && $scope.categorySearch) {
              asset._PrivateData.categoriesNew = [];
              asset._PrivateData.categoriesNew = $scope.categorySearch.filter(function (category) {
                return category.title === 'TV Series';
              });
            }

            if (data.Country && $scope.countrySearch) {
              data.Country = data.Country.split(',')[0].trim();
              if (data.Country === 'USA') data.Country = 'United States';
              if (data.Country === 'UK') data.Country = 'United Kingdom of Great Britain and Northern Ireland';

              var country = $scope.countrySearch.filter(function (country) {
                return country.title === data.Country.split(',')[0];
              });

              if (country.length) {
                asset._PrivateData.countriesNew = country[0];
              }
            }

            $q.all(requestQ)
              .then(function () {
                if (personSearchResult.length) {
                  asset._PrivateData.personsNew = personSearchResult;
                  asset._PrivateData.roles = MetadataService.Persons.Prepare(personSearchResult);
                }
                deferred.resolve();
              })
              .catch(function (errors) {
                deferred.reject(errors);
              });

            return deferred.promise;
          })();

          $q.all(allQ)
            .then(function (response) {
              $scope.$parent.loading = false;
              $rootScope.hideLinearProgress('#modalLoader');
              ToastService.Big({
                title: 'Import',
                text: 'Import from IMDb successfully finished. Check all fields before saving',
                color: 'green',
                icon: 'emoticon-happy'
              }, 10 * 60 * 1000);
            })
            .catch(function (reason) {
              $rootScope.debugInfo(reason);
              $scope.$parent.loading = false;
              $rootScope.hideLinearProgress('#modalLoader');
              ToastService.Big({
                title: 'Import',
                text: 'Import from IMDb was\'t finished correctly. Check all fields before saving',
                color: 'deep-orange',
                icon: 'emoticon-sad'
              }, 10 * 60 * 1000);
            });

          return deferred.promise;
        } else {
          $scope.$parent.loading = false;
          $rootScope.hideLinearProgress('#modalLoader');
          ToastService.Big({
            title: 'Import',
            text: 'Import from IMDb was\'t finished correctly. Check all fields before saving',
            color: 'deep-orange',
            icon: 'emoticon-sad'
          }, 10 * 60 * 1000);
        }
      };
      return service;
    }]);
